/*
 * @Author: gang.liu
 * @Date: 2021-06-28 16:55:13
 * @LastEditTime: 2021-06-28 16:56:26
 * @LastEditors: gang.liu
 * @Description: 
 * @api-property: 
 * @api-event: 
 * @api-method: 
 */
import { MainLayout } from "@/layout";
import { loginRoute } from "@/config/RouteConfig";

const login = {
  path: "",
  component: MainLayout,
  children: [
    {
      ...loginRoute,
      component: () => import("@/views/Login"),
    },
  ],
};

export default login;

